import ReactDOM from 'react-dom';
import { ContactUsState } from './ContactUsState.js';


$(function () {
    const dataElement = document.getElementById('js-init-data');
    const data = JSON.parse(dataElement.textContent);

    ReactDOM.render(
        <ContactUsState data={data}
            ref={(contactUsState) => {
                // Storing the component (not the DOM node) for use in legacy JS
                window.contactUsState = contactUsState;
            }} />,
        document.getElementById('content'),
    );
});

$(window).on('signinTriggered', function () {
    window.contactUsState.signinTriggered();
});
